import { API, Endpoints, Project } from "@brg/api";
import { FlexBox, useToasts } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
//@ts-ignore
import Switch from 'react-input-switch';
import { protectProcessStatuses, protectStatuses } from "shared/helpers/protectStatus";
import styled, { css } from "styled-components";

const Wrapper = styled(FlexBox)<{ status?: boolean, minOffset?: boolean }>`
    align-items: flex-end;
    justify-content: end;

    .showcase-switcher {
        width: 48px;
        height: 24px;
        margin: 0 16px 0 0;
        border-radius: 19px;
        display: flex;
        justify-content: center;

        span:not(:last-child) {
            ${({ status }) => !!status ? css`
                    background-color: #27AE60;
                `: css`
                    background-color: #70706F;
            `};
        }

        span:last-child {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);

            ${({ status }) => !!status ? css`
                left: 57%;
            `: css`
                left: 10%;
            `};
        }
    }

    .input-span-text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        white-space: nowrap;
        color: #909090;
        padding-bottom: 2px;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        .showcase-switcher {
            margin: 0 8px 0 0;
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        justify-content: start;
        margin-top: ${({ minOffset }) => minOffset ? '0px' : '16px'};
    }
`;

export const MaskSwitcher: FC<{ project: Project, minOffset?: boolean }> = ({ project, minOffset }) => {
const toasts = useToasts();
const switchRef = useRef(null);
const { t } = useTranslation();

//@ts-ignore
const protectValue = useMemo(() => (!!project?.isProtected) , [project])

const onToggleSwitch = () => {
    const action = !!(project as any)?.isProtected? 'disabled' : 'enabled';

    const isCantBeDisabled = (project as any)?.protectedStatus === protectProcessStatuses.InProcess;

    if (isCantBeDisabled) {
      toasts.error(t('toasts.can_be_disabled_protect'));
      return;
    }

    //@ts-ignore
    const confirmation = window.confirm(t(!!project?.isProtected ? 'toasts.user_wont_unprotect' : 'toasts.user_wont_protect'));
                      
    if (confirmation) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Book/Protect`)
        .post()
        .body({
          projectId: project?.projectId ?? '',
          action: protectStatuses[action]
        })
        .send()
        .then((r) => {
          if (r?.status === 403) {                              
            toasts.error(t('project_edit.frames.permissions_protect'));
            return;
          }
            window.location.reload();
        });
    }
}

    return (
        <Wrapper ref={switchRef} direction="row" directionMobile="row" width={'100%'} status={protectValue} minOffset={minOffset}>
            <Switch className={'showcase-switcher'} value={protectValue} onChange={onToggleSwitch} />
            <span className={'input-span-text'}> {t('project_edit.mask_on')}</span>
        </Wrapper>
    )
}import { API, Endpoints, Project } from "@brg/api";
import { FlexBox, useToasts } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
//@ts-ignore
import Switch from 'react-input-switch';
import { protectProcessStatuses, protectStatuses } from "shared/helpers/protectStatus";
import styled, { css } from "styled-components";

const Wrapper = styled(FlexBox)<{ status?: boolean, minOffset?: boolean }>`
    align-items: flex-end;
    justify-content: end;

    .showcase-switcher {
        width: 48px;
        height: 24px;
        margin: 0 16px 0 0;
        border-radius: 19px;
        display: flex;
        justify-content: center;

        span:not(:last-child) {
            ${({ status }) => !!status ? css`
                    background-color: #27AE60;
                `: css`
                    background-color: #70706F;
            `};
        }

        span:last-child {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);

            ${({ status }) => !!status ? css`
                left: 57%;
            `: css`
                left: 10%;
            `};
        }
    }

    .input-span-text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        white-space: nowrap;
        color: #909090;
        padding-bottom: 2px;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        .showcase-switcher {
            margin: 0 8px 0 0;
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        justify-content: start;
        margin-top: ${({ minOffset }) => minOffset ? '0px' : '16px'};
    }
`;

export const MaskSwitcher: FC<{ project: Project, minOffset?: boolean }> = ({ project, minOffset }) => {
const toasts = useToasts();
const switchRef = useRef(null);
const { t } = useTranslation();

//@ts-ignore
const protectValue = useMemo(() => (!!project?.isProtected) , [project])

const onToggleSwitch = () => {
    const action = !!(project as any)?.isProtected? 'disabled' : 'enabled';

    const isCantBeDisabled = (project as any)?.protectedStatus === protectProcessStatuses.InProcess;

    if (isCantBeDisabled) {
      toasts.error(t('toasts.can_be_disabled_protect'));
      return;
    }

    //@ts-ignore
    const confirmation = window.confirm(t(!!project?.isProtected ? 'toasts.user_wont_unprotect' : 'toasts.user_wont_protect'));
                      
    if (confirmation) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Book/Protect`)
        .post()
        .body({
          projectId: project?.projectId ?? '',
          action: protectStatuses[action]
        })
        .send()
        .then((r) => {
          if (r?.status === 403) {                              
            toasts.error(t('project_edit.frames.permissions_protect'));
            return;
          }
            window.location.reload();
        });
    }
}

    return (
        <Wrapper ref={switchRef} direction="row" directionMobile="row" width={'100%'} status={protectValue} minOffset={minOffset}>
            <Switch className={'showcase-switcher'} value={protectValue} onChange={onToggleSwitch} />
            <span className={'input-span-text'}> {t('project_edit.mask_on')}</span>
        </Wrapper>
    )
}